import { EXLY_BACKEND_API_HOST } from "repoV2/constants/apis";

export const GET_SALE_PAGE_DETAILS_API_URL = `${EXLY_BACKEND_API_HOST}/marketing/sales`;
export const GET_SALE_PAGE_SECTIONS_DETAILS_API_URL = `${EXLY_BACKEND_API_HOST}/marketing/sales/page/section/list`;
export const GET_SALE_PAGE_CONTENT_CATALOGUE_API_URL = `${EXLY_BACKEND_API_HOST}/host/recorded/curriculum`;
